'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ = require('./');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var myBidsSortOrders = (0, _extends3.default)({}, _.itemSortOrders, {
    BID_RECENT_FIRST: 'BID_RECENT_FIRST',
    BID_OLDEST_FIRST: 'BID_OLDEST_FIRST'
    /*eslint-enable */
});

exports.default = myBidsSortOrders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/myBidsSortOrders.js
// module id = 11Md
// module chunks = 57